import { PERMISSIONS, useCheckPermissions } from "../../../Auth"
import { Navigate } from "../../../router-utils"

export default function OrganizationProfilePage() {
	const { hasPermission } = useCheckPermissions()
	// Land on the hotels only for the users who can view them, so /org never
	// opens a forbidden page. B2B Sources is open to every org user.
	return (
		<Navigate
			to={
				hasPermission(PERMISSIONS.VIEW_HOTELS)
					? "/org/hotels"
					: "/org/trip-sources"
			}
			replace
		/>
	)
}
